<template>
  <div class="card">
    <svg @click="overwriteWishlist" class="card__wishlist" width="51" viewBox="0 0 51 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_59_1210)">
        <rect x="3.99976" y="0.00012207" width="43" height="32" rx="4" fill="white"/>
      </g>
      <path d="M31.8942 10.5209C33.2652 11.9043 33.3177 14.1304 32.0135 15.578L25.4785 22.8312L18.9443 15.578C17.6401 14.1304 17.6927 11.9043 19.0636 10.5209C20.5944 8.97621 23.1155 9.11736 24.4679 10.8232L25.4789 12.098L26.4891 10.823C27.8415 9.11721 30.3635 8.97626 31.8942 10.5209Z" :stroke="isProductInWishlist ? '#e33b23' : 'currentColor'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :fill="isProductInWishlist ? '#e33b23' : 'white'" />
    </svg>
    <router-link :to="translations.i18nRoute({ name: 'product', params: { productUuid: product.uuid } })">
      <img class="card__image" :src="product.images.edges[0].node.image" :alt="product.name">
    </router-link>
    <div class="card__inner">
      <p class="card__name">{{ product.name }}</p>
      <div class="card__block">
        <div class="card__block-inner">
          <img src="@icons/currency.svg" alt="currency">
          {{ product.price }}
        </div>
        <div class="card__block-inner">
          <img src="@icons/ratingIcon.svg" alt="rating">
          {{ product.rating }}
        </div>
      </div>
      <div class="card__bottom">
        <button class="card__bottom-button" @click="overwriteCart">
          {{ isProductInCart ? t('buttons.removeFromCart') : t('buttons.addToCart') }}
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.39041 1.66016H1.60168C1.97467 1.66016 2.1615 1.66016 2.31363 1.72745C2.44776 1.78678 2.56244 1.88231 2.64514 2.00344C2.73878 2.1406 2.77259 2.32375 2.84009 2.68935L4.53956 11.8948L12.7444 11.8948C13.1012 11.8948 13.2802 11.8948 13.428 11.8318C13.5585 11.7761 13.6711 11.6859 13.7547 11.5712C13.8493 11.4415 13.8893 11.2679 13.9694 10.921L13.97 10.9185L15.2054 5.56504L15.2057 5.56392C15.3271 5.03771 15.388 4.77397 15.3211 4.5671C15.2625 4.38558 15.1391 4.23169 14.9754 4.13373C14.7887 4.022 14.5189 4.022 13.978 4.022H3.35861M13.1996 15.8312C12.7648 15.8312 12.4123 15.4787 12.4123 15.0439C12.4123 14.6091 12.7648 14.2566 13.1996 14.2566C13.6344 14.2566 13.9869 14.6091 13.9869 15.0439C13.9869 15.4787 13.6344 15.8312 13.1996 15.8312ZM5.32681 15.8312C4.89201 15.8312 4.53953 15.4787 4.53953 15.0439C4.53953 14.6091 4.89201 14.2566 5.32681 14.2566C5.76162 14.2566 6.1141 14.6091 6.1141 15.0439C6.1141 15.4787 5.76162 15.8312 5.32681 15.8312Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="card__bottom-tags">
          <div class="card__bottom-tag tag1">HTML</div>
          <div class="card__bottom-tag tag2">CSS</div>
          <div class="card__bottom-tag tag3">JS</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";
import {Orders} from "@/core/api/orders.js";
import {ElNotification} from "element-plus";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {computed} from "vue";
import {useRouter} from "vue-router";
import {useWishlistStore} from "@/stores/wishlist.js";
import {Wishlist} from "@/core/api/wishlist.js";

const {t} = useI18n()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const router = useRouter()

const props = defineProps({
  product: Object
})

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder ? cartStore.currentOrder.uuid : null
})
const wishlistUuid = computed(() => {
  return wishlistStore.wishlist ? wishlistStore.wishlist.uuid : ''
})
const user = computed(() => {
  return authStore.user ? authStore.user : null
})

const isProductInCart = computed(() => {
  return cartStore.currentOrder?.orderProducts?.edges.find((prod) => prod.node.product.uuid === props.product.uuid)
})
const isProductInWishlist = computed(() => {
  const el = wishlistStore.wishlist.products?.edges.find(
    (el) => el?.node?.uuid === props.product.uuid
  );

  return !!el;
});

const overwriteCart = async () => {
  if (user.value) {
    if (isProductInCart.value) {
      const res = await Orders.overwriteCart("removeOrderProduct", accessToken.value, orderUuid.value, props.product.uuid);

      cartStore.setCurrentOrders(res.data.removeOrderProduct.order)
    } else {
      const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, props.product.uuid);
      cartStore.setCurrentOrders(res.data.addOrderProduct.order)

      if (res.errors) {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      } else {
        ElNotification({
          message: t('popup.addToCart', { product: props.product.name }),
          type: "success"
        });
      }
    }
  } else {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })
  }
}

const overwriteWishlist = async () => {
  if (user.value) {
    if (isProductInWishlist.value) {
      const res = await Wishlist.overwriteWishlist('removeWishlistProduct', accessToken.value, wishlistUuid.value, props.product.uuid)
      wishlistStore.wishlist = res.data.removeWishlistProduct.wishlist
    } else {
      const res = await Wishlist.overwriteWishlist('addWishlistProduct', accessToken.value, wishlistUuid.value, props.product.uuid)
      wishlistStore.wishlist = res.data.addWishlistProduct.wishlist

      if (res.data.addWishlistProduct) {
        ElNotification({
          message: t('popup.addToWishlist', { product: props.product.name }),
          type: "success"
        });
      } else {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      }
    }
  } else {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 359px;
  padding: 15px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.61);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(9.5px);
  position: relative;

  &__wishlist {
    position: absolute;
    top: 34px;
    right: 31px;
    cursor: pointer;
    transition: 0.2s;

    color: #2B3044;

    &:hover {
      color: $red;
    }
  }

  &__image {
    width: 100%;
    height: 184px;
    object-fit: cover;
    border-radius: 20px 20px 0 0;
  }

  &__inner {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 25px;
  }

  &__name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 16px;
    font-weight: 700;
    color: #2B3044;
    font-family: Syne, sans-serif;
  }

  &__block {
    display: flex;
    align-items: center;
    gap: 10px;

    &-inner {
      display: flex;
      align-items: center;
      gap: 5px;

      & img {
        width: 34px;
      }
    }
  }

  &__icons {
    display: flex;
    align-items: center;
    gap: 5px;

    & img {
      width: 32px;
    }
  }

  &__bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-button {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
      transition: 0.2s;
      padding: 7px 10px;
      border-radius: 4px;
      background-color: #2B3044;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

      font-size: 10px;
      font-weight: 500;
      color: $white;

      &:hover {
        background-color: #494e65;
      }
    }

    &-tags {
      display: flex;
      align-items: center;
      gap: 7px;
    }

    &-tag {
      border-radius: 4px;
      width: 50px;
      padding-block: 9px;
      display: grid;
      place-items: center;

      font-size: 11px;
      color: $white;
      font-weight: 500;
    }
  }
}

.tag1 {
  background-color: #FE855F;
}
.tag2 {
  background-color: #5F9FFE;
}
.tag3 {
  background-color: #FED15F;
}
</style>